import { getInfo, getOpenid, logout,moPanLogin,xiaoYiLogin,heJiaLogin } from '@/api/login'
import { getToken, setToken,setUserId, removeToken, getUrlKey, getCodeApi, setDeviceId } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    cpr: '',
    roles: [],
    status: false,//是否获取到信息
    online: 0,
    model: 'S10',
    channelTag: '',
    yunpanSwitch: 0,
    telecomYunpanSwitch: 0,
    ltYunpanSwitch: 0,
    isBindPhone: 0,
    userChannelTag: '',
    rewardSwitch:0,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_CLOUD_USER_PEN_RELATION: (state, cpr) => {
      state.cpr = cpr
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_ONLINE: (state, online) => {
      state.online = online
    },
    SET_MODEL: (state, model) => {
      state.model = model
    },
    SET_CHANNEL_TAG: (state, channelTag) => {
      state.channelTag = channelTag
    },
    SET_YUNPAN_SWITCH: (state, yunpanSwitch) => {
      state.yunpanSwitch = yunpanSwitch
    },
    SET_TELECOMYUNPAN_SWITCH: (state, telecomYunpanSwitch) => {
      state.telecomYunpanSwitch = telecomYunpanSwitch
    },
    SET_LTYUNPAN_SWITCH: (state, ltYunpanSwitch) => {
      state.ltYunpanSwitch = ltYunpanSwitch
    },
    SET_IS_BIND_PHONE: (state, isBindPhone) => {
      state.isBindPhone = isBindPhone
    },
    SET_USER_CHANNEL_TAG: (state, userChannelTag) => {
      state.userChannelTag = userChannelTag
    },
    SET_REWARD_SWITCH: (state, rewardSwitch) => {
      state.rewardSwitch = rewardSwitch
    }

  },

  actions: {
    // 登录
    Login({ commit }, sourceUrl) {
      return new Promise((resolve, reject) => {
        let code = getUrlKey("code");//获取url参数code
        if (code) { //拿到code， code传递给后台接口换取opend
          getOpenid(code).then(res => {
            let token = res.data;
            setToken(token)
            commit('SET_TOKEN', token)
            resolve(token)
          }).catch(error => {
            reject(error)
          })
        } else {
          getCodeApi(sourceUrl);
        }

      })
    },
    // 手机号登录
    SMSLogin({ commit }, token) {
      return new Promise((resolve, reject) => {
          setToken(token)
          commit('SET_TOKEN', token)
          resolve(token)
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data) {
            var cpr = data.cpr;
            commit('SET_CLOUD_USER_PEN_RELATION', cpr)
            if (data.isOnline) {
              commit('SET_ONLINE', data.isOnline)
            }
            commit('SET_ROLES', data.pcrList)
            commit('SET_STATUS', true)
            commit('SET_MODEL', data.model)
            commit('SET_CHANNEL_TAG', data.channelTag)
            commit('SET_YUNPAN_SWITCH', data.yunpanSwitch)
            commit('SET_TELECOMYUNPAN_SWITCH', data.telecomYunpanSwitch)
            commit('SET_LTYUNPAN_SWITCH', data.ltYunpanSwitch)
            commit('SET_IS_BIND_PHONE', data.isBindPhone)
            commit('SET_USER_CHANNEL_TAG', data.userChannelTag)
            commit('SET_REWARD_SWITCH', data.rewardSwitch)
          }
          resolve(response)

        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_CLOUD_USER_PEN_RELATION', '')
          commit('SET_ONLINE', 0)
          commit('SET_ROLES', [])
          commit('SET_STATUS', false)
          commit('SET_MODEL', 'S10')
          commit('SET_CHANNEL_TAG', '')
          commit('SET_YUNPAN_SWITCH', 0)
          commit('SET_TELECOMYUNPAN_SWITCH', 0)
          commit('SET_IS_BIND_PHONE', 0)
          commit('SET_USER_CHANNEL_TAG', '')
          commit('SET_REWARD_SWITCH', 0)
          //清除code信息
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 云盘小程序登录
    YunAppletLogin({ commit }, param) {
      return new Promise((resolve, reject) => {
        var token = param.token;
        var deviceId = param.deviceId;
        setDeviceId(deviceId);
        setToken(token)
        commit('SET_TOKEN', token)
        resolve(param)
      })
    },
    //魔盘登录
    MoPanLogin({ commit }, param) {
      return new Promise((resolve, reject) => {
        moPanLogin(param).then(res=>{
          var token = res.data;
          setToken(token)
          setUserId(param.userId)
          commit('SET_TOKEN', token)
          resolve(param)
        })
      })
    },
    //小翼登录
    XiaoYiLogin({ commit }, param) {
      return new Promise((resolve, reject) => {
        xiaoYiLogin(param).then(res => {
          console.log(res);
          var data = res.data;
          setToken(data.token);
          setUserId(data.userId);
          commit("SET_TOKEN", data.token);
          resolve(param);
        });
      });
    },
    //和家亲登录
    HeJiaLogin({ commit }, param) {
      return new Promise((resolve, reject) => {
        heJiaLogin(param).then(res => {
          console.log(res);
          var data = res.data;
          setToken(data.token);
          setUserId(data.userId);
          commit("SET_TOKEN", data.token);
          resolve(param);
        });
      });
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js